import React, { useState } from 'react';
import { galleryImages } from '../mockData';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All' },
    { id: 'interior', name: 'Clinic Interiors' },
    { id: 'equipment', name: 'Equipment' }
  ];

  const filteredImages = selectedCategory === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="heading-1 text-white mb-6">GALLERY</h1>
            <p className="body-large text-gray-300">
              Explore our modern clinic facilities and state-of-the-art equipment
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all ${
                  selectedCategory === category.id
                    ? 'bg-white text-gray-900'
                    : 'bg-transparent text-gray-400 border border-gray-700 hover:border-white hover:text-white'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-lg aspect-[4/3] bg-gray-900"
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="heading-5 text-white">{image.title}</h3>
                    <p className="caption text-gray-300 mt-1">
                      {image.category === 'interior' ? 'Clinic Interior' : 'Equipment'}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6 text-center">
          <h2 className="heading-2 text-white mb-6">
            EXPERIENCE OUR MODERN FACILITIES
          </h2>
          <p className="body-medium text-gray-400 max-w-3xl mx-auto mb-8">
            Our clinic features contemporary design and advanced dental technology to ensure 
            your comfort and receive the highest quality care. Every detail has been carefully 
            considered to create a welcoming, professional environment.
          </p>
          <p className="body-small text-gray-500">
            Note: You can replace these images with your own clinic photos for a personalized gallery
          </p>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
